import React from "react"

export const MailSignupResultModal = ({
  mail_signup_result_modal_state,
  set_button_loading,
  set_mail_signup_result_modal_state,
}) => {
  const { is_active, request_was_successfull } = mail_signup_result_modal_state
  const close_modal = () => {
    set_button_loading(false)
    set_mail_signup_result_modal_state({
      ...mail_signup_result_modal_state,
      is_active: false,
    })
  }
  return (
    <div data-nosnippet className={`modal${is_active ? " is-active" : ""}`}>
      <div
        className="modal-background"
        onClick={close_modal}
        role="button"
        tabIndex="-1"
        onKeyDown={() => {}}
        aria-label="Close Fail Modal"
      ></div>
      <div className="modal-content">
        <div
          className="box is-flex is-flex-direction-column"
          style={{ maxWidth: 592, minHeight: 230, margin: "0 auto" }}
        >
          <p className="title is-4 mb-2 has-text-mitternachtsblau">
            {request_was_successfull
              ? "Vielen Dank für Ihre Anmeldung!"
              : "Irgendetwas ist schief gelaufen..."}
          </p>
          <hr className="is-mitternachtsblau is-slim my-3" />
          {request_was_successfull ? (
            <p className="has-text-mitternachtsblau">
              Um Ihre Anmeldung zum kostenlosen Newsletter abzuschließen, <br />
              <b>
                bestätigen Sie bitte die Mail, die Sie in Kürze von uns
                bekommen.
              </b>
            </p>
          ) : (
            <p className="has-text-mitternachtsblau">
              Leider ist Ihre Anmeldung fehlgeschlagen.
              <br />
              Bitte versuchen Sie es erneut, oder{" "}
              <b>schreiben Sie eine E-Mail an:</b>
              <br />
              <a href="mailto:service@bi-medien.de">service@bi-medien.de</a>
            </p>
          )}

          <div className="mt-auto ml-auto">
            <button
              className="button is-sonnengelb"
              aria-label="delete"
              onClick={close_modal}
            >
              <b>Schließen</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
